import cx from "clsx";
import ThemeProvider from "kreate-common/modules/kreate-ui/components/ThemeProvider";
import React from "react";

import Layout from "./components/Layout";
import SectionCollectionOfTheDay from "./containers/SectionCollectionOfTheDay";
import SectionCollections from "./containers/SectionCollections";
import SectionStats from "./containers/SectionStats";
import SectionTopGalleries from "./containers/SectionTopGalleries";
import useSecondaryHighlight from "./hooks/useSecondaryHighlight";
import styles from "./index.module.scss";

import ErrorViewer from "@/modules/kreate-components/components/ErrorViewer";
import Footer from "@/modules/kreate-components/components/Footer";
import KreateHead from "@/modules/kreate-components/components/KreateHead";
import NavbarV4 from "@/modules/kreate-components/components/NavbarV4";
import { useThemeFromSessionPreferences } from "@/modules/kreate-components/hooks/useThemeFromSessionPreferences";

type Props = {
  className?: string;
  style?: React.CSSProperties;
};

export default function PageMarketplace({ className, style }: Props) {
  const fromSessionPreferences = useThemeFromSessionPreferences();
  const [secondaryHighlight$Data, secondaryHighlight$Error] =
    useSecondaryHighlight();
  if (secondaryHighlight$Error) {
    return (
      <div className={cx(styles.container, className)} style={style}>
        <ErrorViewer error={secondaryHighlight$Error} />
      </div>
    );
  }
  return (
    <ThemeProvider theme={fromSessionPreferences.theme} asChild>
      <Layout.Article className={cx(styles.container, className)} style={style}>
        <KreateHead
          title={"Marketplace | Kreate"}
          description={undefined}
          imageUrl={undefined}
          url={undefined}
        />
        <Layout.Header>
          <NavbarV4 product="market" makeTransparentUnlessScrolledDown />
        </Layout.Header>
        <Layout.Main>
          <div className={styles.backdropContainer}>
            <div className={styles.backdrop}></div>
          </div>
          <div className={styles.content}>
            <SectionCollectionOfTheDay
              style={{ paddingTop: "8px" }}
              collection={secondaryHighlight$Data?.featuredCollection}
            />
            <SectionCollections
              style={{ marginTop: "80px" }}
              featuredCollections={secondaryHighlight$Data?.pickedCollections}
              trendingCollections={secondaryHighlight$Data?.trendingCollections}
              sponsoredCollection={secondaryHighlight$Data?.sponsoredCollection}
            />
            <SectionTopGalleries
              style={{ marginTop: "80px" }}
              topGalleries={secondaryHighlight$Data?.topGalleries}
            />
            <SectionStats style={{ margin: "80px 0" }} />
          </div>
        </Layout.Main>
        <Layout.Footer>
          <Footer />
        </Layout.Footer>
      </Layout.Article>
    </ThemeProvider>
  );
}
